import { useCallback } from 'react';

import { useBrowserQueryState } from '@telialt/common-hooks/src/useBrowserQueryState';

import { SEARCH_PAGE_QUERY_PARAM } from '../constants';

export const usePageOffset = (itemsPerPage: number, initialPage?: number) => {
    const [pageNumberParam, setPageNumberParam] = useBrowserQueryState<string>(
        SEARCH_PAGE_QUERY_PARAM,
        '1',
        initialPage?.toString(),
    );

    const pageNumber = !isNaN(parseInt(pageNumberParam, 10)) ? parseInt(pageNumberParam, 10) : 1;

    const changePageNumber = useCallback(
        (page: number) => {
            setPageNumberParam(page.toString());
        },
        [setPageNumberParam],
    );

    return { offset: (pageNumber - 1) * itemsPerPage, pageNumber, changePageNumber };
};
